import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';

const PrivateRoute: React.FC = () => {
  const { verify } = useAuth();
  const { isAuthentic } = verify();

  return isAuthentic ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
